const { default: Axios } = require("axios");

const  getFile = (url, extension, name) => {
    Axios({
    url: url,
    method: 'GET',
    responseType: 'blob',
    }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${name}.${extension}`);
        document.body.appendChild(link);
        link.click();
    });
}

export default getFile;